import { FileItemProps } from "../../types";
import { DottedMenu } from "../dotted-menu";
import { FC } from "react";
import style from "../style.module.scss";
import { ExtensionFileIcon } from "../extension-file-icon";
// import { Thumbnail } from "../thumbnail";

export const FileListItem: FC<FileItemProps> = (props) => {
  const {
    item,
    moveFileActionAllowed,
    showRemoveModal,
    showRenameModal,
    showMoveModal,
    showPreviewModal,
  } = props;
  const {
    key,
    fileName,
    formattedLastModified,
    formattedSizeName,
    fileExtensionType,
    thumbnail,
    fileExtension,
  } = item;

  const handleDeleteAction = async () =>
    showRemoveModal({ name: fileName, path: key, isFolder: false, thumbnail });

  const handleRenameAction = async () => {
    showRenameModal({ path: key, isFolder: false, name: fileName });
  };

  const handleMoveAction = async () => {
    showMoveModal({ name: fileName, path: key, isFolder: false });
  };

  const handlePreviewAction = async () => {
    await showPreviewModal({ fileName, fileExtension, fileExtensionType });
  };

  return (
    <li className="list-group-item px-0 d-flex justify-content-between align-items-start">
      <div className="d-flex align-items-center text-light gap-2">
        {/* Disable thumbnail for 400 bad request */}
        {/* {thumbnail ? (
            <Thumbnail
              url={thumbnail}
              filename={fileName}
              fileExtensionType={fileExtensionType}
            />
          ) : ( */}
        <ExtensionFileIcon fileExtensionType={fileExtensionType} />
        {/* )} */}
        <div className={style["list-item"]}>
          <p className="text-truncate">{fileName}</p>
          <p className="text-truncate">{`${formattedLastModified} • ${formattedSizeName}`}</p>
        </div>
      </div>
      <div>
        <DottedMenu
          id={fileName}
          actions={[
            {
              label: "Anteprima",
              action: handlePreviewAction,
              tooltipDisabledMessage:
                fileExtensionType === "image" || fileExtensionType === "pdf"
                  ? undefined
                  : "Anteprima non disponibile per questo tipo di file",
            },
            {
              label: "Sposta",
              action: handleMoveAction,
              tooltipDisabledMessage: moveFileActionAllowed
                ? undefined
                : "Non ci sono cartelle dove spostare il file",
            },
            { label: "Elimina", action: handleDeleteAction },
            { label: "Rinomina", action: handleRenameAction },
          ]}
        />
      </div>
    </li>
  );
};
